const SaintGobainLogo = props => {
  return (
    <svg
      version='1.1'
      id='Calque_1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='55 65 400 160'
      width={props.width ? props.width : '196px'}
      height={props.height ? props.height : '100%'}
    >
      <g>
        <defs>
          <rect id='SVGID_1_' y='0' />
        </defs>
      </g>
      <path
        d='M400.9,164.2h-24.4l-0.2-0.2l-21.5-21.3c-0.9-0.9-2.2-1.1-3.4-0.7c-1.2,0.5-1.9,1.6-1.9,2.9v19.3h-6.4v-47.9
      c0-0.8-0.4-1.7-1-2.2l-17.9-16.9c-0.6-0.5-1.3-0.8-2.1-0.8h-8.9c-1.7,0-3.1,1.4-3.1,3.1v64.7h-6.3V60.4c0-1.3-0.8-2.4-1.9-2.9
      c-1.1-0.5-2.5-0.2-3.4,0.7l-29.6,30c-0.6,0.6-0.9,1.4-0.9,2.2v23.2l-12.1-9c-1.1-0.8-2.7-0.8-3.8,0.1l-27.5,22.1
      c-0.7,0.6-1.2,1.5-1.2,2.4v35.2h-6.2v-19.4c0-6.8-4.7-14.1-13.4-14.1c-8.7,0-13.4,7.3-13.4,14.1v19.3l-6.3,0v-13.2
      c0-5.3-3.7-11-10.5-11c-6.8,0-10.5,5.7-10.5,11v13.2l-6.3,0l0-0.6c0-2.7,0-6.1,0-7.4c0-4.5-4.3-8.5-9.2-8.5c-4.9,0-9.2,4-9.2,8.5v8
      l-27.6,0c-1.7,0-3.1,1.4-3.1,3.1c0,0.8,0.3,1.6,0.9,2.2c0.6,0.6,1.4,0.9,2.2,0.9l30.7,0c0.8,0,1.6-0.3,2.2-0.9
      c0.6-0.6,0.9-1.4,0.9-2.2v-10.6c0-1.1,1.2-2.8,3-2.8c1.7,0,3,1.6,3,2.9c0,0.8,0,10.5,0,10.5c0,1.7,1.4,3.1,3.1,3.1l12.5,0
      c1.7,0,3.1-1.4,3.1-3.1v-16.3c0-1.7,0.9-4.8,4.3-4.8c3.4,0,4.3,3.2,4.3,4.8v16.3c0,1.7,1.4,3.1,3.1,3.1l12.5,0
      c0.8,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.4,0.9-2.2V145c0-2.7,1.5-7.9,7.2-7.9c5.3,0,7.2,4.7,7.2,7.9v22.5c0,1.7,1.4,3.1,3.1,3.1h12.4
      c1.7,0,3.1-1.4,3.1-3.1v-36.8l0.2-0.2l24.3-19.5l13.9,10.4v46.1c0,1.7,1.4,3.1,3.1,3.1h12.4c1.7,0,3.1-1.4,3.1-3.1V129
      c0-1-0.5-1.9-1.2-2.5l-11.2-8.3V91.7l0.2-0.2L297.7,68v99.5c0,1.7,1.4,3.1,3.1,3.1h12.5c1.7,0,3.1-1.4,3.1-3.1v-64.7h4.6l0.2,0.2
      l15.8,14.9v49.6c0,1.7,1.4,3.1,3.1,3.1h12.6c1.7,0,3.1-1.4,3.1-3.1v-15l17.3,17.1c0.6,0.6,1.4,0.9,2.2,0.9h25.7
      c1.7,0,3.1-1.4,3.1-3.1C404,165.6,402.6,164.2,400.9,164.2z M280.5,130.6v33.7h-6.2v-38.4L280.5,130.6z'
      />
      <path
        d='M73.7,200.2c-5.5-1.7-7.9-2.7-7.9-5.9c0-2.8,3.7-3.8,7-3.8c2.8,0,5.8,0.8,7.9,2.2c0.5,0.3,1.1,0.4,1.6,0.3
      c0.6-0.1,1-0.5,1.3-1.1l0.9-1.9c0.5-0.9,0.2-2-0.7-2.6c-3-1.9-7.1-3.1-10.9-3.1c-8,0-13.3,4.1-13.3,10.2c0,7.9,6.7,9.9,12,11.5
      c5.6,1.7,8.1,2.8,8,6.1c0,3.4-3.9,4.6-7.6,4.6c-3.5,0-7.4-1.9-9.7-4c-0.5-0.4-1.1-0.7-1.7-0.6c-0.6,0.1-1.2,0.4-1.5,1l-1.1,1.8
      c-0.5,0.8-0.3,1.8,0.3,2.5c3.5,3.4,8.7,5.5,13.6,5.5c8.3,0,14-4.3,14-10.8C86,204,79.2,201.9,73.7,200.2'
      />
      <path
        d='M110.5,185.6c-0.3-0.7-1.1-1.2-1.8-1.2h-2.2c-0.8,0-1.5,0.5-1.8,1.2l-15.6,34.3c-0.3,0.6-0.2,1.4,0.1,1.9
      c0.4,0.6,1,0.9,1.7,0.9h2.3c0.8,0,1.5-0.5,1.8-1.2l3.9-8.6h17.5l3.9,8.6c0.3,0.7,1.1,1.2,1.8,1.2h2.3c0.7,0,1.3-0.4,1.7-0.9
      c0.4-0.6,0.4-1.3,0.1-1.9L110.5,185.6z M101.6,206.9l5.9-13.2l6,13.2H101.6z'
      />
      <path
        d='M136.4,184.4h-2.1c-1.1,0-2,0.9-2,2v34.3c0,1.1,0.9,2,2,2h2.1c1.1,0,2-0.9,2-2v-34.3
      C138.4,185.3,137.5,184.4,136.4,184.4'
      />
      <path
        d='M179.2,184.4h-2c-1.1,0-2,0.9-2,2v25l-19.3-26.2c-0.4-0.5-1-0.8-1.6-0.8h-2.4c-1.1,0-2,0.9-2,2v34.3
      c0,1.1,0.9,2,2,2h2.1c1.1,0,2-0.9,2-2v-25l19.2,26.2c0.4,0.5,1,0.8,1.6,0.8h2.4c1.1,0,2-0.9,2-2v-34.3
      C181.3,185.3,180.4,184.4,179.2,184.4'
      />
      <path
        d='M214.6,184.4h-25.2c-1.1,0-2,0.9-2,2v2c0,1.1,0.9,2,2,2h9.6v30.3c0,1.1,0.9,2,2,2h2.1c1.1,0,2-0.9,2-2v-30.3
      h9.6c1.1,0,2-0.9,2-2v-2C216.7,185.3,215.7,184.4,214.6,184.4'
      />
      <path
        d='M229.7,203.1h-11c-1.1,0-2,0.9-2,2v1.7c0,1.1,0.9,2,2,2h11c1.1,0,2-0.9,2-2v-1.7
      C231.7,204.1,230.8,203.1,229.7,203.1'
      />
      <path
        d='M272.4,201.9h-1.9c0,0,0,0,0,0h-6.1c-1.1,0-2,0.9-2,2v2.1c0,1.1,0.9,2,2,2h4.1v6.3c-2.4,1.6-5.3,2.5-8.2,2.5
      c-7.6,0-13.7-5.9-13.7-13.2c0-7.3,6.2-13.2,13.7-13.2c3.5,0,7,1.3,9.5,3.6c0.4,0.4,1,0.6,1.5,0.5c0.6,0,1.1-0.3,1.4-0.7l1.2-1.5
      c0.7-0.9,0.6-2.1-0.2-2.8c-3.7-3.2-8.5-5-13.4-5c-10.9,0-19.9,8.6-19.9,19.2c0,10.6,8.9,19.3,19.8,19.3c4.9,0,9.8-1.8,13.5-5
      c0.4-0.4,0.7-0.9,0.7-1.5v-12.4C274.4,202.8,273.5,201.9,272.4,201.9'
      />
      <path
        d='M301.1,184.4c-10.9,0-19.8,8.6-19.8,19.2c0,10.6,8.9,19.3,19.8,19.3s19.8-8.6,19.8-19.3
      C320.9,193,312,184.4,301.1,184.4 M301.1,216.8c-7.5,0-13.6-5.9-13.6-13.2c0-7.2,6.1-13.1,13.6-13.1c7.5,0,13.6,5.9,13.6,13.1
      C314.8,210.9,308.6,216.8,301.1,216.8'
      />
      <path
        d='M353.4,202.5c2.1-1.8,3.2-4.4,3.2-7.6c0-6.5-4.9-10.5-12.7-10.5h-14c-1.1,0-2,0.9-2,2v34.3c0,1.1,0.9,2,2,2H344
      c9,0,14.4-4.2,14.4-11.3C358.4,207.6,356.6,204.4,353.4,202.5 M343.9,200H334v-9.5h9.9c3,0,6.7,0.8,6.7,4.7
      C350.5,198.4,348.3,200,343.9,200 M334,206.1h9.9c3.1,0,8.4,0.7,8.4,5.2c0,4.5-4.6,5.4-8.4,5.4H334V206.1z'
      />
      <path
        d='M383.3,185.6c-0.3-0.7-1.1-1.2-1.8-1.2h-2.2c-0.8,0-1.5,0.5-1.8,1.2l-15.6,34.3c-0.3,0.6-0.2,1.4,0.1,1.9
      c0.4,0.6,1,0.9,1.7,0.9h2.3c0.8,0,1.5-0.5,1.8-1.2l3.9-8.6h17.5l3.9,8.6c0.3,0.7,1.1,1.2,1.8,1.2h2.3c0.7,0,1.3-0.4,1.7-0.9
      c0.4-0.6,0.4-1.3,0.1-1.9L383.3,185.6z M374.3,206.9l5.9-13.2l6,13.2H374.3z'
      />
      <path
        d='M409.2,184.4h-2.1c-1.1,0-2,0.9-2,2v34.3c0,1.1,0.9,2,2,2h2.1c1.1,0,2-0.9,2-2v-34.3
      C411.2,185.3,410.3,184.4,409.2,184.4'
      />
      <path
        d='M452,184.4h-2c-1.1,0-2,0.9-2,2v25l-19.3-26.2c-0.4-0.5-1-0.8-1.6-0.8h-2.4c-1.1,0-2,0.9-2,2v34.3
      c0,1.1,0.9,2,2,2h2.1c1.1,0,2-0.9,2-2v-25l19.2,26.2c0.4,0.5,1,0.8,1.6,0.8h2.4c1.1,0,2-0.9,2-2v-34.3
      C454,185.3,453.1,184.4,452,184.4'
      />
    </svg>
  )
}
export default SaintGobainLogo
